var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8723_1477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1242 12.0989L10.5527 2.76519C9.71732 1.05776 7.28418 1.05776 6.44761 2.76519L1.87618 12.0989C1.72304 12.412 1.61332 12.7915 1.85561 13.0429C3.45218 14.7035 13.547 14.7035 15.1447 13.0429C15.3859 12.7915 15.2773 12.412 15.1242 12.0989Z",
    stroke: "#103046",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51855 5.98462V8.57433",
    stroke: "#103046",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51863 12.4395C7.96638 12.4395 7.5187 11.9917 7.5187 11.4395C7.5187 10.8872 7.96638 10.4395 8.51863 10.4395C9.07087 10.4395 9.51855 10.8872 9.51855 11.4395C9.51855 11.9917 9.07087 12.4395 8.51863 12.4395Z",
    fill: "#103046"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8723_1477"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 16.5 0.00292969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarningTriangle);
export default __webpack_public_path__ + "static/media/alertWarningTriangle.6b63e68b1e7a37780e02fe4e044ac3a9.svg";
export { ForwardRef as ReactComponent };